export const FETCH_USER_GEAR = 'FETCH_USER_GEAR'
export const FETCH_USER_GEAR_LOADING = 'FETCH_USER_GEAR_LOADING'
export const FETCH_USER_GEAR_ERROR = 'FETCH_USER_GEAR_ERROR'
export const FETCH_USER_GEAR_SUCCESS = 'FETCH_USER_GEAR_SUCCESS'
